import './vfigma.parcel.mjs'


import { registerVueComponentAndAngularBindings} from '/vodalys/vvuejs'

import VFigmaPage from './VFigmaPage.vue'
registerVueComponentAndAngularBindings('vfigma:page', 'vfigmaPage', VFigmaPage)
